// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3iXy2","colCheckbox":"styles_colCheckbox__29OWK"};